import React from 'react'
import { useNavigate } from 'react-router-dom'
import usePostPSN from '../../api/v1/auth/usePostPSN'
import { useAuth } from '../../providers/auth'
import { FirstPartyPlatformType } from '../../types/Account'
import AuthCallback from '../AuthCallback'

const PlayStationAuthCallback: React.FC = () => {
  const navigate = useNavigate()
  const authContext = useAuth()

  return (
    <AuthCallback
      usePostAuth={usePostPSN}
      onSuccess={(psnAuthResponse) => {
        authContext.setAuthToken(psnAuthResponse.jwt, {
          username: psnAuthResponse.online_id,
          suffix: '', // PSN never uses a suffix like Xbox sometimes does
        })
        navigate('/')
      }}
      platform={FirstPartyPlatformType.PLAYSTATIONNETWORK}
    />
  )
}

export default PlayStationAuthCallback
